import { AfterViewInit, Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgxFileDropEntry } from 'ngx-file-drop';
import { ToastrService } from 'ngx-toastr';
import { ServicesService } from 'src/services/services.service';

type CardSizeUnit = 'px' | 'mm' | 'in';
type PreviewDisplayField = {
  label: string;
  value: string;
};

@Component({
  selector: 'app-app-custom-card',
  templateUrl: './app-custom-card.component.html',
  styleUrls: ['./app-custom-card.component.scss'],
  standalone: false
})
export class AppCustomCardComponent implements AfterViewInit {
  selected_image: any;
  message: any;
  imagefileURL: any | ArrayBuffer | null;
  commercial_invoice_image: any;
  Shipment_Form: any;
  imgType: any;
  image1: any;
  image2: any;
  image3: any;

  selectedCard: any;
  Card_Image_Name: any;
  type: any;
  event_id: any;
  user_id: any;

  readonly printDpi: number = 300;
  readonly sizeUnits: { value: CardSizeUnit; label: string }[] = [
    { value: 'px', label: 'Pixels (px)' },
    { value: 'mm', label: 'Millimeters (mm)' },
    { value: 'in', label: 'Inches (in)' }
  ];
  readonly previewSampleFields: PreviewDisplayField[] = [
    { label: 'Name', value: 'V Think Solution' },
    // { label: 'City', value: 'Ahmedabad' },
    { label: 'Mobile', value: '1234567890' }
  ];
  @ViewChild('previewContainer') previewContainer?: ElementRef<HTMLDivElement>;

  cardWidth: number = 350;
  cardHeight: number = 500;
  cardY: number = 240;
  cardX: number = 10;
  pdf_bg: any = 'no';
  layout: any = 'horizontal';
  color: any = '#000000';
  font_size: number = 20;
  selectedColor: string = '#FF0000';
  originalAspectRatio: number = this.cardWidth / this.cardHeight;
  company_ad: any = 'on';
  company_ad_text: any = 'Event Ticketing by www.aieventzo.com';
  qr_height: any = 120;
  qr_width: any = 120;
  Enable_Editing: boolean = false;
  selectedCategory: any = null;
  hasUnsavedChanges: boolean = false;
  pendingCategoryToLoad: any = null;
  sizeUnit: CardSizeUnit = 'px';
  sizeInput: string = `${this.cardWidth} x ${this.cardHeight}`;
  previewAvailableWidth: number = 560;
  previewAvailableHeight: number = 760;
  backgroundImageWidth: number = 0;
  backgroundImageHeight: number = 0;

  private lastAppliedWidth: number = this.cardWidth;
  private lastAppliedHeight: number = this.cardHeight;
  private textMeasureCanvas?: HTMLCanvasElement;

  scan_type: any = 'qrcode';
  content: any = 'yes';
  show_id: any = 'yes';
  show_qr: any = 'yes';

  constructor(
    private service: ServicesService,
    private route: ActivatedRoute,
    private toastr: ToastrService
  ) { }

  get previewScale(): number {
    if (!this.cardWidth || !this.cardHeight) {
      return 1;
    }

    return Math.min(
      1,
      this.previewAvailableWidth / this.cardWidth,
      this.previewAvailableHeight / this.cardHeight
    );
  }

  get previewCardWidth(): number {
    return Math.max(1, Math.round(this.cardWidth * this.previewScale));
  }

  get previewCardHeight(): number {
    return Math.max(1, Math.round(this.cardHeight * this.previewScale));
  }

  get previewTransform(): string {
    return `scale(${this.previewScale})`;
  }

  get previewScaleLabel(): string {
    return `${Math.round(this.previewScale * 100)}% preview scale`;
  }

  get pixelSizeLabel(): string {
    return `${this.cardWidth} x ${this.cardHeight} px`;
  }

  get printSizeLabel(): string {
    const widthInches = this.formatDimension(this.convertFromPixels(this.cardWidth, 'in'));
    const heightInches = this.formatDimension(this.convertFromPixels(this.cardHeight, 'in'));
    const widthMillimeters = this.formatDimension(this.convertFromPixels(this.cardWidth, 'mm'));
    const heightMillimeters = this.formatDimension(this.convertFromPixels(this.cardHeight, 'mm'));

    return `${widthInches} x ${heightInches} in • ${widthMillimeters} x ${heightMillimeters} mm`;
  }

  get footerFontSize(): number {
    return 10;
  }

  get footerHeight(): number {
    return this.company_ad === 'on' ? 25 : 0;
  }

  get previewTextLines(): string[] {
    return [
      'ID: 0000',
      ...this.previewSampleFields.map((field) => `${field.label}: ${field.value}`)
    ];
  }

  get previewScanWidth(): number {
    const width = this.toPositiveNumber(this.qr_width, 120);
    return this.scan_type === 'barcode' ? width * 2 : width;
  }

  get previewScanHeight(): number {
    const height = this.toPositiveNumber(this.qr_height, 120);
    return this.scan_type === 'barcode' ? Math.max(1, Math.round(height / 2)) : height;
  }

  get previewHorizontalTextX(): number {
    return this.toNumber(this.cardX, 10) + this.previewScanWidth + 20;
  }

  get previewVerticalTextTop(): number {
    return this.toNumber(this.cardY, 240) + this.previewScanHeight + 15;
  }

  get previewVerticalTextCenterX(): number {
    return this.toNumber(this.cardX, 10) + Math.round(this.previewScanWidth / 2);
  }

  get previewContentBottomLimit(): number {
    return this.cardHeight - this.footerHeight;
  }

  get previewLayoutWarning(): string {
    if (this.content === 'no') {
      return '';
    }

    const maxTextWidth = this.getMaxPreviewLineWidth();
    const textHeight = this.getPreviewTextBlockHeight();

    if (this.layout === 'horizontal') {
      const availableWidth = Math.max(0, this.cardWidth - this.previewHorizontalTextX);
      const textBottom = this.toNumber(this.cardY, 240) + textHeight;
      const hasRightClipping = maxTextWidth > availableWidth;
      const hasBottomClipping = textBottom > this.previewContentBottomLimit;

      if (!hasRightClipping && !hasBottomClipping) {
        return '';
      }

      if (hasRightClipping && hasBottomClipping) {
        return 'Generator warning: text will clip on the right side and near the bottom in the final card image.';
      }

      if (hasRightClipping) {
        return 'Generator warning: text will clip on the right side in the final card image.';
      }

      return 'Generator warning: text will clip near the bottom in the final card image.';
    }

    const safeWidth = Math.max(
      0,
      2 * Math.min(this.previewVerticalTextCenterX, this.cardWidth - this.previewVerticalTextCenterX)
    );
    const textBottom = this.previewVerticalTextTop + textHeight;
    const hasSideClipping = maxTextWidth > safeWidth;
    const hasBottomClipping = textBottom > this.previewContentBottomLimit;

    if (!hasSideClipping && !hasBottomClipping) {
      return '';
    }

    if (hasSideClipping && hasBottomClipping) {
      return 'Generator warning: centered text will clip at the card sides and bottom in the final card image.';
    }

    if (hasSideClipping) {
      return 'Generator warning: centered text will clip at the card sides in the final card image.';
    }

    return 'Generator warning: centered text will clip near the bottom in the final card image.';
  }

  get hasBackgroundImage(): boolean {
    return !!this.image1;
  }

  get recommendedImageSizeLabel(): string {
    return `${this.cardWidth} x ${this.cardHeight} px minimum`;
  }

  get backgroundImageSizeLabel(): string {
    return `${this.backgroundImageWidth} x ${this.backgroundImageHeight} px`;
  }

  get printQualityRatio(): number {
    if (!this.backgroundImageWidth || !this.backgroundImageHeight || !this.cardWidth || !this.cardHeight) {
      return 0;
    }

    return Math.min(
      this.backgroundImageWidth / this.cardWidth,
      this.backgroundImageHeight / this.cardHeight
    );
  }

  get printQualityClass(): string {
    if (!this.hasBackgroundImage || !this.backgroundImageWidth || !this.backgroundImageHeight) {
      return 'quality-pending';
    }

    if (this.printQualityRatio >= 1.2) {
      return 'quality-strong';
    }

    if (this.printQualityRatio >= 1) {
      return 'quality-safe';
    }

    return 'quality-risk';
  }

  get printQualityLabel(): string {
    if (!this.hasBackgroundImage) {
      return 'No background image';
    }

    if (!this.backgroundImageWidth || !this.backgroundImageHeight) {
      return 'Checking image quality';
    }

    if (this.printQualityRatio >= 1.2) {
      return 'Sharp for print';
    }

    if (this.printQualityRatio >= 1) {
      return 'Good for print';
    }

    return 'Blurry risk in print';
  }

  get printQualityHint(): string {
    if (!this.hasBackgroundImage) {
      return `Upload at least ${this.recommendedImageSizeLabel} to keep the print sharp.`;
    }

    if (!this.backgroundImageWidth || !this.backgroundImageHeight) {
      return `Recommended minimum: ${this.recommendedImageSizeLabel}.`;
    }

    if (this.printQualityRatio >= 1) {
      return `Background image ${this.backgroundImageSizeLabel}. Recommended minimum: ${this.recommendedImageSizeLabel}.`;
    }

    return `Background image ${this.backgroundImageSizeLabel} is smaller than the required ${this.recommendedImageSizeLabel}. Upload a higher-resolution image to avoid blur.`;
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.event_id = params['event_id'];
      this.user_id = params['user_id'];
      this.Get_Card(this.event_id);
    });
    const User = sessionStorage.getItem('User');
    this.syncDimensionState();
    this.Get_Card(this.event_id);

    if (User == 'superadmin' && this.event_id) {
      this.Enable_Editing = true;
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.refreshPreviewBounds());
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    this.refreshPreviewBounds();
  }

  onFileDrop(files: NgxFileDropEntry[], type: any): void {
    console.log("files", files);

    // Ensure only the first file is processed (drag and drop can give an array of files)
    if (files.length > 0) {
      const file = files[0].fileEntry;

      if (file.isFile) {
        const droppedFile = file as any as FileSystemFileEntry;
        console.log("droppedFile", droppedFile);

        droppedFile.file((fileData: File) => {
          // Handle file processing
        });
      }
    }
  }

  Error_Image(event: any) {
    const target = event.target as HTMLImageElement;
    target.src = 'https://demo.vthinksolution.com/angular/importcrm/upload/shipment/default.png';
  }

  removeFile(type: any): void {
    switch (type) {
      case 'Commercial_Invoice':
        this.selected_image = '';  // Clear the file name
        this.commercial_invoice_image = '';  // Optionally, clear the uploaded image reference
        this.Shipment_Form.patchValue({ commercial_invoice: this.commercial_invoice_image });
        break;
    }
  }

  adjustCardSize(event: Event): void {
    const img = event.target as HTMLImageElement;
    if (img) {
      this.backgroundImageWidth = img.naturalWidth;
      this.backgroundImageHeight = img.naturalHeight;
    }
  }

  previewpimage(files: any): void {
    if (files.length === 0) {
      return;
    }

    const file = files[0];
    const reader = new FileReader();

    reader.readAsDataURL(file);

    reader.onload = (_event) => {
      this.imagefileURL = reader.result;

      // Create a new Image object to get dimensions
      const img = new Image();
      img.src = this.imagefileURL as string;

      img.onload = () => {
        const width = img.width;
        const height = img.height;

        console.log('Image Width:', width);
        console.log('Image Height:', height);

        this.backgroundImageWidth = width;
        this.backgroundImageHeight = height;
        this.applyCardDimensions(width, height);
        this.markUnsaved();

        // Continue uploading after dimensions are known
        this.imgType = 'icard';
        this.service.uploadimage(this.imagefileURL, this.imgType).subscribe((data: any) => {
          this.image1 = data['image_name'];
        });
      };
    };
  }

  markUnsaved() {
    this.hasUnsavedChanges = true;
  }

  onSizeUnitChange(): void {
    this.updateSizeInputFromCard();
  }

  applySizeInput(): void {
    const parsedSize = this.parseSizeInput(this.sizeInput);

    if (!parsedSize) {
      this.toastr.error('Use 1050 x 1650, 88.9 x 139.7 mm, or 3.5 x 5.5 in');
      this.updateSizeInputFromCard();
      return;
    }

    this.sizeUnit = parsedSize.unit;
    this.applyCardDimensions(
      this.convertToPixels(parsedSize.width, parsedSize.unit),
      this.convertToPixels(parsedSize.height, parsedSize.unit)
    );
    this.markUnsaved();
  }


  onQrWidthChange() {
    this.qr_width = this.toPositiveNumber(this.qr_width, 120);

    if (this.scan_type === 'qrcode') {
      this.qr_height = this.qr_width; // maintain 1:1
    } else if (this.scan_type === 'barcode') {
      this.qr_height = Math.round(this.qr_width / 3); // 3:1 ratio
    }

    this.markUnsaved();
  }

  onQrHeightChange() {
    this.qr_height = this.toPositiveNumber(this.qr_height, 120);

    if (this.scan_type === 'qrcode') {
      this.qr_width = this.qr_height; // maintain 1:1
    } else if (this.scan_type === 'barcode') {
      this.qr_width = Math.round(this.qr_height * 3); // 3:1 ratio
    }

    this.markUnsaved();
  }

  onScanTypeChange() {
    this.qr_width = this.toPositiveNumber(this.qr_width, 120);

    if (this.scan_type === 'qrcode') {
      this.qr_height = this.qr_width;
    } else if (this.scan_type === 'barcode') {
      this.qr_height = Math.round(this.qr_width / 3);
    }

    this.markUnsaved();
  }

  Get_Card(event_id: any): void {
    this.service.get_card(event_id).subscribe((res: any) => {
      this.Card_Image_Name = res.data || [];

      // Automatically select first category on load
      if (this.Card_Image_Name.length > 0) {
        this.loadCard(this.Card_Image_Name[0]);
      }
    });
  }

  handleCategorySwitch(category: any) {
    // No unsaved changes → switch directly
    if (!this.hasUnsavedChanges) {
      this.loadCard(category);
      return;
    }

    // Ask user before switching
    this.pendingCategoryToLoad = category;

    if (confirm("You have unsaved changes.\nDo you want to save changes before switching?")) {
      this.saveBeforeSwitching();
    } else {
      // Ask if they want to discard or cancel
      if (confirm("Discard changes?")) {
        this.hasUnsavedChanges = false;
        this.loadCard(this.pendingCategoryToLoad);
        this.pendingCategoryToLoad = null;
      }
    }
  }

  saveBeforeSwitching() {
    this.Update_Card();     // Save your card
    this.hasUnsavedChanges = false;

    if (this.pendingCategoryToLoad) {
      this.loadCard(this.pendingCategoryToLoad);
      this.pendingCategoryToLoad = null;
    }
  }

  // Load specific category card data
  loadCard(card: any) {
    this.selectedCategory = card.category_id;

    this.selectedCard = card.design_name;
    this.image1 = card.image1;
    this.image2 = card.image2;
    this.image3 = card.image3;
    this.backgroundImageWidth = 0;
    this.backgroundImageHeight = 0;
    this.scan_type = card.scan_type || 'qrcode';
    this.content = card.content || 'yes';
    this.show_id = card.show_id || 'yes';
    this.show_qr = card.show_qr || 'yes';
    this.cardWidth = this.toPositiveNumber(card.width, 350);
    this.cardHeight = this.toPositiveNumber(card.height, 500);
    this.cardY = this.toNumber(card.y_axis, 240);
    this.cardX = this.toNumber(card.x_axis, 10);
    this.pdf_bg = card.pdf_bg || 'no';
    this.layout = card.layout || 'horizontal';
    this.color = card.color || '#000000';
    this.qr_height = this.toPositiveNumber(card.qr_height, 120);
    this.qr_width = this.toPositiveNumber(card.qr_width, 120);
    this.font_size = this.toPositiveNumber(card.font_size, 20);
    this.company_ad = card.company_ad || 'on';
    this.company_ad_text = card.company_ad_text || 'Event Ticketing by www.aieventzo.com';

    this.syncDimensionState();
  }


  Update_Card(): void {
    const parsedSize = this.parseSizeInput(this.sizeInput);

    if (!parsedSize) {
      this.toastr.error('Enter a valid print size before saving');
      return;
    }

    this.sizeUnit = parsedSize.unit;
    this.applyCardDimensions(
      this.convertToPixels(parsedSize.width, parsedSize.unit),
      this.convertToPixels(parsedSize.height, parsedSize.unit)
    );

    const Card_Data = {
      category_id: this.selectedCategory,
      design_name: this.selectedCard,
      event_id: this.event_id,
      image1: this.image1,
      image2: this.image2,
      image3: this.image3,
      scan_type: this.scan_type,
      content: this.content,
      show_id: this.show_id,
      show_qr: this.show_qr,
      width: this.cardWidth,
      height: this.cardHeight,
      y_axis: this.cardY,
      x_axis: this.cardX,
      pdf_bg: this.pdf_bg,
      layout: this.layout,
      color: this.color,
      qr_width: this.qr_width,
      qr_height: this.qr_height,
      font_size: this.font_size,
      company_ad: this.company_ad,
      company_ad_text: this.company_ad_text,
    };

    this.service.edit_icard(Card_Data).subscribe(() => {
      this.hasUnsavedChanges = false;
      this.toastr.success("Card Design Updated Successfully");
    });
  }

  private applyCardDimensions(nextWidth: number, nextHeight: number): void {
    const width = this.toPositiveNumber(nextWidth, this.lastAppliedWidth);
    const height = this.toPositiveNumber(nextHeight, this.lastAppliedHeight);
    const previousWidth = this.toPositiveNumber(this.lastAppliedWidth, width);
    const previousHeight = this.toPositiveNumber(this.lastAppliedHeight, height);
    const scaleX = width / previousWidth;
    const scaleY = height / previousHeight;
    const fontScale = Math.min(scaleX, scaleY);

    this.cardWidth = width;
    this.cardHeight = height;
    this.cardX = this.scalePosition(this.cardX, scaleX);
    this.cardY = this.scalePosition(this.cardY, scaleY);
    this.qr_width = this.scaleDimension(this.qr_width, scaleX, 120);
    this.qr_height = this.scaleDimension(this.qr_height, scaleY, 120);
    this.font_size = this.scaleDimension(this.font_size, fontScale, 20);

    this.syncDimensionState();
  }

  private syncDimensionState(): void {
    this.originalAspectRatio = this.cardHeight ? this.cardWidth / this.cardHeight : 1;
    this.lastAppliedWidth = this.cardWidth;
    this.lastAppliedHeight = this.cardHeight;
    this.updateSizeInputFromCard();
    this.refreshPreviewBounds();
  }

  private updateSizeInputFromCard(): void {
    const width = this.convertFromPixels(this.cardWidth, this.sizeUnit);
    const height = this.convertFromPixels(this.cardHeight, this.sizeUnit);
    const unitSuffix = this.sizeUnit === 'px' ? '' : ` ${this.sizeUnit}`;

    this.sizeInput = `${this.formatDimension(width)} x ${this.formatDimension(height)}${unitSuffix}`;
  }

  private parseSizeInput(rawSize: string): { width: number; height: number; unit: CardSizeUnit } | null {
    if (!rawSize) {
      return null;
    }

    const match = rawSize
      .trim()
      .toLowerCase()
      .replace(/,/g, '')
      .match(/^(\d+(?:\.\d+)?)\s*(?:x|\*|×)\s*(\d+(?:\.\d+)?)\s*(px|mm|millimeter|millimeters|in|inch|inches)?$/);

    if (!match) {
      return null;
    }

    const width = Number(match[1]);
    const height = Number(match[2]);
    const unit = this.normalizeUnit(match[3]) || this.sizeUnit;

    if (!Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0) {
      return null;
    }

    return { width, height, unit };
  }

  private normalizeUnit(unit: string | undefined): CardSizeUnit | null {
    switch (unit) {
      case 'px':
        return 'px';
      case 'mm':
      case 'millimeter':
      case 'millimeters':
        return 'mm';
      case 'in':
      case 'inch':
      case 'inches':
        return 'in';
      default:
        return null;
    }
  }

  private convertToPixels(value: number, unit: CardSizeUnit): number {
    switch (unit) {
      case 'mm':
        return Math.round((value / 25.4) * this.printDpi);
      case 'in':
        return Math.round(value * this.printDpi);
      default:
        return Math.round(value);
    }
  }

  private convertFromPixels(value: number, unit: CardSizeUnit): number {
    switch (unit) {
      case 'mm':
        return (value / this.printDpi) * 25.4;
      case 'in':
        return value / this.printDpi;
      default:
        return value;
    }
  }

  private formatDimension(value: number): string {
    if (!Number.isFinite(value)) {
      return '0';
    }

    if (Math.abs(value - Math.round(value)) < 0.01) {
      return `${Math.round(value)}`;
    }

    const precision = value < 10 ? 2 : 1;
    return value.toFixed(precision).replace(/\.0$/, '').replace(/(\.\d*[1-9])0+$/, '$1');
  }

  private getMaxPreviewLineWidth(): number {
    return this.previewTextLines.reduce((maxWidth, line) => {
      return Math.max(maxWidth, this.measurePreviewText(line).width);
    }, 0);
  }

  private getPreviewTextBlockHeight(): number {
    const lineHeights = this.previewTextLines.map((line) => this.measurePreviewText(line).height);

    if (!lineHeights.length) {
      return 0;
    }

    let totalHeight = lineHeights[0];

    if (lineHeights.length > 1) {
      totalHeight += 10;
    }

    for (let index = 1; index < lineHeights.length; index += 1) {
      totalHeight += lineHeights[index];

      if (index < lineHeights.length - 1) {
        totalHeight += 5;
      }
    }

    return totalHeight;
  }

  private measurePreviewText(text: string): { width: number; height: number } {
    const fallback = {
      width: Math.ceil(text.length * this.font_size * 0.58),
      height: Math.ceil(this.font_size * 1.1)
    };

    if (typeof document === 'undefined') {
      return fallback;
    }

    if (!this.textMeasureCanvas) {
      this.textMeasureCanvas = document.createElement('canvas');
    }

    const context = this.textMeasureCanvas.getContext('2d');
    if (!context) {
      return fallback;
    }

    context.font = `${this.font_size}px "Futura Std Book", Futura, "Trebuchet MS", Arial, sans-serif`;
    const metrics = context.measureText(text);
    const height = Math.ceil(
      (metrics.actualBoundingBoxAscent || this.font_size * 0.8) +
      (metrics.actualBoundingBoxDescent || this.font_size * 0.3)
    );

    return {
      width: Math.ceil(metrics.width),
      height
    };
  }

  private scalePosition(value: any, ratio: number): number {
    return Math.round(this.toNumber(value, 0) * (Number.isFinite(ratio) ? ratio : 1));
  }

  private scaleDimension(value: any, ratio: number, fallback: number): number {
    return Math.max(1, Math.round(this.toPositiveNumber(value, fallback) * (Number.isFinite(ratio) ? ratio : 1)));
  }

  private refreshPreviewBounds(): void {
    const containerWidth = this.previewContainer?.nativeElement.clientWidth || 0;
    const horizontalPadding = window.innerWidth < 768 ? 28 : 40;
    const viewportOffset = window.innerWidth < 768 ? 250 : 320;

    if (containerWidth > 0) {
      this.previewAvailableWidth = Math.max(220, containerWidth - horizontalPadding);
    }

    this.previewAvailableHeight = Math.max(260, window.innerHeight - viewportOffset);
  }

  private toNumber(value: any, fallback: number): number {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  private toPositiveNumber(value: any, fallback: number): number {
    const parsed = Number(value);
    return Number.isFinite(parsed) && parsed > 0 ? Math.round(parsed) : fallback;
  }

}
